import { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router';
import compose from 'recompose/compose';
import { useStore } from 'store';
import { fetchReceivedGifts } from 'store/actions/giftTable';
import { GiftsReceivedLayout, Modal } from 'components';
import { TableList } from 'components/gifts-table/TableList';
import { ThanksMessage } from 'pages/GiftsReceived';
import { useWindowSize } from 'hooks';
import { withAgentPage, withLayout } from 'hocs';
import { useStorage64 } from 'hooks/useStorageBase64';
import { AGENT_STAFF, CURRENT_GIFT_TABLE, PROFILE_DATA } from 'constants/storage64';
import giftIcon from 'assets/img/iconregalo.svg';
import { columns as desktopColumns, mobileColumns } from './columns';
import { getGiftTable as getGiftTableInfo } from 'services/api/table';
import styles from './styles.module.scss'
import { Link } from 'react-router-dom';
import iconGift from 'assets/img/iconregalo.svg'

const ALL_ORDERS = true;

function GiftsReceived({ queryAgentToken, queryAgentId, queryTableId }) {
  const [showThanksMessage, setShowThanksMessage] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [thanksMessage, setThanksMessage] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [giftTableId, setGiftTableId] = useState(0);
  const [profileData] = useStorage64(PROFILE_DATA, '');
  const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const [giftTableInfo] = useStore((state) => state.giftTable.giftTable);
  const [listOfReceivedGifts, dispatch] = useStore(
    (state) => state.giftTable.listOfReceivedGifts
  );
  const [showThanks, setShowThanks] = useState(false);
  const [agentStaff] = useStorage64(AGENT_STAFF, {});
  useEffect(async () => {
    if (!giftTableInfo.hasOwnProperty('thanks_message')) {
      const giftTableData = giftTableInfo?.evento
        ? await getGiftTableInfo(giftTableInfo.evento, true, false) : null;
      setShowThanks(giftTableData?.thanks_message?.type_id === 2)
    }
    else {
      setShowThanks(giftTableInfo?.thanks_message?.type_id === 2);
    }
  }, [giftTableInfo, giftTableId]);

  useEffect(() => {
    setGiftTableId(queryTableId || storageGiftTable.id);
    if (queryAgentId && queryTableId) {
      dispatch(fetchReceivedGifts(queryTableId || storageGiftTable.id, ALL_ORDERS));
    }
  }, [queryAgentId, queryTableId]);

  const [, { isMobile }] = useWindowSize();

  useEffect(() => {
    if (agentStaff==null){
      setGiftTableId(queryTableId || storageGiftTable.id);
      dispatch(fetchReceivedGifts(queryTableId || storageGiftTable.id, false));
    }
  },[]);

  const history = useHistory();

  const handleRowClick = (data) => {
   history.push(`/regalos-recibidos/${data.target.id}/details`);
  };

  const handleWelcomeClick = (data) => {
    setOrderId(data.target.id);
    setShowThanksMessage(data);
  };

  const handleClickDetail = (e, item) => {
    setShowMessage(true);
    setThanksMessage(item);
  };
  const adminheader = sessionStorage.getItem('admin_header');
  //console.log('HEADERADMIN',adminheader);
  // const tableId = useQuery().get('table_id');

  useEffect(() => {
    window.localStorage.removeItem('currentEvent');
    window.localStorage.removeItem('currentEventExit');
    if (!listOfReceivedGifts.results.list.length)
      dispatch(
        fetchReceivedGifts(
          queryTableId || storageGiftTable.id,
          queryTableId ? ALL_ORDERS : false
        )
      );
  }, [profileData, queryTableId]);

  const columns = useMemo(
    () => (isMobile ? mobileColumns : desktopColumns),
    [isMobile]
  );

    //console.log('listOfReceivedGifts.results?.list',listOfReceivedGifts.results?.list);
    const icon = localStorage.getItem('icon');
    //console.log('icon',icon);
  return (
    <>
      <main className="gifts-root">
        <Modal
          icon={giftIcon}
          show={showMessage}
          titleClassName="text-center"
          title={`De ${thanksMessage.whoGaveTheGift}`}
          subtitleClassName="text-center mt-4"
          subtitle={thanksMessage.congratulationMessage}
          onClose={() => setShowMessage(false)}
          onAction={() => setShowMessage(false)}
          className="pt-4 pb-1"
          type="single"
        />
        <ThanksMessage
          tableId={giftTableId}
          orderId={orderId}
          show={showThanksMessage}
          onClose={() => setShowThanksMessage(false)}
        />
        <GiftsReceivedLayout id={queryTableId || giftTableInfo?.id} agent={queryAgentId} title='Mis regalos recibidos' icono='1' TableHero_icon={icon}>
          {
            isMobile ? (
                listOfReceivedGifts.results.list.length>0 ? (
                  <div className={styles['list-gift-container']}>
                    <span className={styles.title}>REGALOS</span>
                    <div className={styles['gifts-container']}>
                      { 
                        listOfReceivedGifts.results?.list.map(item => (
                          <div className={styles['item-gift']} key={item.id}>
                            <article className={styles['name-and-price']}>
                              <span className={styles.name}>{item.whoGaveTheGift}</span>
                              <span className={styles.price}>${item.price}</span>
                            </article>
                            <Link to = {`regalos-recibidos/${item.id}/detailsv2`} className={styles.link}>
                              Ver regalo
                            </Link>
                          </div>
                        ))
                      }
                    </div>
                  </div>
              ):(
                <>
                      <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                      }}>
                        <img src={iconGift} alt="" style={{width: '60px',}}/>
                      </div>
                      <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                      }}>
                        <p className="text-center mt-5">Lo sentimos, aún no recibes ningún regalo, recuerda compartir tu mesa de regalos con tus invitados.</p>
                      </div>
                </>
              )              
            ) : (
              <TableList
                className="mt-md-4 mb-md-5"
                data={listOfReceivedGifts.results?.list || []}
                columns={columns({
                  onWelcomeClick: handleWelcomeClick,
                  onClickDetail: handleClickDetail,
                  onHandleRowClick: handleRowClick,
                })}
                //onRowClick={handleRowClick}
                clickableRow
                showThanks={showThanks}
                message={isMobile ? "Lo sentimos, aún no recibes ningún regalo, recuerda compartir tu mesa de regalos con tus invitados.": "No tienes regalos recibidos aún"}
                queryAgentId={queryAgentId}
                queryTableId={queryTableId}
                queryAgentToken={queryAgentToken}
              />
            )
          }
        </GiftsReceivedLayout>
      </main>
    </>
  );
}

export default compose(withLayout, withAgentPage())(GiftsReceived);
